import React from "react";

import { Card, Typography } from "@packages/ds";

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  error?: Error;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: unknown) {
    return { error: error as Error };
  }

  render() {
    if (this.state.error)
      return (
        <Card padding="32px">
          <Typography.Title tag="h3">An error occurred</Typography.Title>
          <Typography.BodyText>{this.state.error.message}</Typography.BodyText>
        </Card>
      );

    return this.props.children;
  }
}
